import React from "react";
import {
  Dialog,
  DialogContent,
  //   DialogActions,
  CircularProgress,
  Typography,
  Box,
  //   Button,
} from "@mui/material";
import { CheckCircle, Cancel } from "@mui/icons-material";

const ModalLoading = ({ open, status, message, referenceId, onClose }) => {
  const renderIcon = () => {
    if (message && message.includes("Login Successful")) {
      return <CheckCircle sx={{ fontSize: 60, color: "green", mb: 2 }} />;
    } else if (message && message.includes("Login Invalid")) {
      return <Cancel sx={{ fontSize: 60, color: "red", mb: 2 }} />;
    }
    return <CircularProgress size={60} sx={{ mb: 2 }} />;
  };

  const statusText =
    message &&
    (message.includes("Login Invalid") || message.includes("Error message"))
      ? "Failed"
      : status;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 200,
      }}
    >
      <DialogContent
        sx={{
          textAlign: "center",
          position: "relative",
          minHeight: "150px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
          }}
        >
          {renderIcon()}
        </Box>
        <Typography variant="h6" gutterBottom>
          {statusText}
        </Typography>
        <Typography variant="body1">{message}</Typography>
        <Typography variant="body2" color="text.secondary">
          Reference: {referenceId}
        </Typography>
      </DialogContent>
      {/* <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default ModalLoading;
